import PropTypes from "prop-types";

const CheckmarkIcon = ({ width = 12, height = 12, className, style }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path
      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"
      fill="none"
      stroke="#4e786a"
      strokeWidth="2"
    />
    <path
      d="M16.3 9.61l-4.57 6a1 1 0 0 1-.79.39 1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1 1 0 1 1 1.6 1.22z"
      fill="#4e786a"
    />
  </svg>
);

CheckmarkIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default CheckmarkIcon;
